import { defineStore } from 'pinia';

import { Roles } from 'api/user_roles';

const state = () => ({
  user: undefined,
});

export const useCurrentUserStore = defineStore('currentUser', {
  state,
  getters: {
    tenantId: (state) => state.user?.tenant?.id,
    tenantName: (state) => state.user?.tenant?.name || '',
    isAdmin: (state) => state.user?.role === Roles.ADMIN,
    isRoot: (state) => state.user?.role === Roles.ROOT,
  },
  actions: {
    setUser(user) {
      this.user = user;
    },
    teardown() {
      this.$reset();
    },
  },
});
